import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  ControlValueAccessor,
  UntypedFormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';

import { ReasonCheckbox } from '@shared/checkbox';
import { Reason } from '@shared/models';

@Component({
  selector: 'mojo-candidate-association-reasons',
  templateUrl: './candidate-association-reasons.component.html',
  styleUrls: ['candidate-association-reasons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: AssociationReasonsComponent,
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: AssociationReasonsComponent,
      multi: true,
    },
  ],
})
export class AssociationReasonsComponent implements ControlValueAccessor {
  @Input() reject = false;

  @Input() set reasons(reasons: Reason[]) {
    this._reasons = reasons || [];
    this.transformedReasons = this.reasons.map((reason) => ({
      value: reason.label,
      name: reason.label,
      selected: false,
      otherReason: reason.otherReason,
    }));

    this.checkUpdateCommentControlValidators(this.transformedReasons.length === 0 && this.reject);
  }

  get reasons(): Reason[] {
    return this._reasons;
  }

  @Input() multiple = false;

  @Input() isRequired = false;

  @Input() commentFormControl: UntypedFormControl;

  transformedReasons: ReasonCheckbox[];

  private _reasons: Reason[];

  selectedReason: string;

  private onTouched = () => {};
  private onChanged = (_: Reason[]) => {};

  writeValue(obj: any): void {}

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate({ value }: UntypedFormControl) {
    if (
      !this.isRequired ||
      this.reasons.length === 0 ||
      (value || []).length > 0 ||
      this.isSelectedOther()
    ) {
      return null;
    }
    return {
      invalid: true,
    };
  }

  private isSelectedOther() {
    return this.transformedReasons.some(
      (reason) => (reason.selected || reason.name === this.selectedReason) && reason.otherReason,
    );
  }

  private checkUpdateCommentControlValidators(required: boolean) {
    if (!!this.commentFormControl) {
      this.commentFormControl.setValidators(required ? Validators.required : []);
      this.commentFormControl.updateValueAndValidity();
    }
  }

  private otherOptionSelected() {
    const isOther = this.isSelectedOther();
    this.checkUpdateCommentControlValidators(isOther);
    this.transformedReasons = isOther
      ? this.transformedReasons.map((reason) =>
          reason.otherReason ? reason : { ...reason, selected: false },
        )
      : this.transformedReasons;
  }

  reasonChange(checkboxes: ReasonCheckbox[]) {
    this.otherOptionSelected();
    const selected = checkboxes
      .filter((checkbox) => checkbox.selected)
      .map((checkbox) => checkbox.value);
    const reasons = this.reasons.filter((reason) => selected.includes(reason.label));
    this.onTouched();
    this.onChanged(reasons);
  }
}
